import { render, staticRenderFns } from "./segmentation.vue?vue&type=template&id=a4697284&"
import script from "./segmentation.vue?vue&type=script&lang=ts&"
export * from "./segmentation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports